import { inject, provideAppInitializer } from "@angular/core";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import { TranslateService } from "@ngx-translate/core";
import { TreesloNativeDateAdapter } from "../adapters/treeslo-native-date.adapter";
import { buildMaterialDateFormats } from "../helpers/material-date-formats.helper";
import { resolveAngularLocale } from "../helpers/locale.helper";
import { MaterialDateLocaleService } from "../services/material-date-locale.service";

export function provideMaterialDateLocale() {
  return [
    { provide: DateAdapter, useClass: TreesloNativeDateAdapter },
    {
      provide: MAT_DATE_LOCALE,
      useFactory: () => {
        const translate = inject(TranslateService);
        return resolveAngularLocale(
          translate.currentLang || translate.defaultLang || "en",
        );
      },
    },
    {
      provide: MAT_DATE_FORMATS,
      useFactory: () => {
        const translate = inject(TranslateService);
        return buildMaterialDateFormats(
          translate.currentLang || translate.defaultLang || "en",
        );
      },
    },
    provideAppInitializer(() => {
      inject(MaterialDateLocaleService);
    }),
  ];
}
